import state from './challengeState.js'
import getters from './challengeGetters.js'
import actions from './challengeActions.js'
import mutations from './challengeMutations.js'

export default {
  state,
  getters,
  actions,
  mutations,
}
